import React from "react";
import {
	Container,
	Row,
	Col,
	Button,
	Navbar,
	Nav,
   NavDropdown,
} from "react-bootstrap";
import { Link } from "react-router-dom";


const Footer = () => (
	<footer>
		<Container fluid className="bg-dark ">
			<Row className="py-4 text-light">
				<Col className="col-md-2 p-3">
					<Link to="/">
						<img src="images/MALogo.png" 
								width="60%"
								alt="MindAntix logo" />

					</Link>
				</Col>
				<Col className="col-md-2 p-3">
					<p className="lead my-1">
						<Link className="footer-link text-light"  to="/about"> About </Link>
					</p>
					<p className="my-0">
						<Link className="footer-link text-light" to="/team"> Team </Link>
					</p>
					<p className="my-0">
						<Link className="footer-link text-light" to="/casestudies"> Case Studies </Link>
					</p>
					<p className="my-0">
						<Link className="footer-link text-light" to="/"> FAQ </Link>
					</p>
				</Col>
				<Col className="col-md-2 p-3">
					<p className="lead my-1" > Products </p>
					<p className="my-0">
						<Link className="footer-link text-light"  to="/online"> - K12 Online Platform </Link>
					</p>
					<p className="my-0">
						<Link className="footer-link text-light"  to="/hackingcreativity"> - Organizational Innovation</Link>
					</p>
					<p className="my-0">
						<Link className="footer-link text-light"  to="/"> - Leadership Training </Link>
					</p>
				</Col>
				<Col className="col-md-1 p-3">
				<p className="lead" > 
					<Link className="footer-link text-light" target="_blank" to="https://blog.mindantix.com/"> Blog </Link>
				</p>
				</Col>
				<Col className="col-md-2 p-3">
					<p className="my-0">
						<Link className="footer-link text-light"  to="/tos"> Terms of Service</Link>
					</p>
					<p className="my-0">
						<Link className="footer-link text-light"  to="/privacy"> Privacy Policy </Link>
					</p>
				</Col>
			</Row>
			<Row className="text-secondary text-center">
			<p className="small py-1 my-0">
				&copy; {new Date().getFullYear()} MindAntix Inc., All Rights Reserved
			</p>

			</Row>

		</Container>
	</footer>
);

export default Footer; 